import { ClipLoader } from "react-spinners";

interface MyProps {
    clickHandler: any;
    shouldOpenGallery: boolean;
    selectedStyle: string;
}

const DownloadingImage = (props: MyProps) => (
    <div
        onClick={props.clickHandler}
        data-content={props.shouldOpenGallery}
        className={props.selectedStyle}
        style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            backgroundColor: "#B4B4B4"
        }}
    >
        <ClipLoader color={"#ffffff"} loading={true} size={"50px"} />
    </div>
);
export default DownloadingImage;
